import { render } from "./signe_vitaux_modal.vue?vue&type=template&id=76479547"
import script from "./signe_vitaux_modal.vue?vue&type=script&lang=js"
export * from "./signe_vitaux_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__